import { useCallback } from 'react';
import { can as canRole, type Action } from '@/config/permissions';
import type { UserRole } from '@/types/user';
import { useAuth } from './useAuth';

export interface Permissions {
  role: UserRole | null;
  /** Whether the current user may perform `action` */
  can: (action: Action) => boolean;
}

/**
 * Permission checks for the signed-in user (see config/permissions.ts)
 *
 * @example
 * ```tsx
 * const { can } = usePermissions();
 * {can('nodes:create') && <Button>Add Node</Button>}
 * ```
 */
export function usePermissions(): Permissions {
  const { user } = useAuth();
  const role = user?.role ?? null;
  const can = useCallback((action: Action) => canRole(role, action), [role]);
  return { role, can };
}
